
// Module
import routes from './routes';

export default angular.module( 'app.verifyEmail.module',
    [] )
    .config(routes)
    .name;



/** WEBPACK FOOTER **
 ** ./src/guest/verifyEmail/index.js
 **/